export default "__VITE_ASSET__727e7f06__"